import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const Cancel = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
            <div className="bg-card border border-border rounded-xl p-8 max-w-md w-full text-center shadow-lg">
                <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Icon name="X" size={32} className="text-red-600 dark:text-red-400" />
                </div>

                <h1 className="text-2xl font-bold text-foreground mb-2">Payment Cancelled</h1>
                <p className="text-muted-foreground mb-8">
                    The payment process was cancelled. No charges were made to your account.
                </p>

                <Button
                    fullWidth
                    variant="outline"
                    onClick={() => navigate('/developer-portal')}
                >
                    Return to Dashboard
                </Button>
            </div>
        </div>
    );
};

export default Cancel;
